var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("section", { staticClass: "section-ac-cleaning" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6 offset-lg-3" },
          [_c("request-form", { attrs: { serviceId: 16 } })],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _vm._m(5)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "header" } }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 offset-md-7 col-md-5 text-center align-self-end"
            },
            [
              _c(
                "div",
                {
                  staticClass: "box-right",
                  attrs: { "data-aos": "fade-left" }
                },
                [
                  _c("span", { staticClass: "title-header" }, [
                    _vm._v("บริการล้างแอร์")
                  ]),
                  _vm._v(" "),
                  _c("h5", [_vm._v("“ให้บริการมาตรฐานสูง ด้วยช่างมืออาชีพ”")])
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "man d-none d-md-block",
        attrs: {
          src: "/static/img/acCleaning/man-header.png",
          "data-aos": "fade-up",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "our-service" } }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "col-12 col-md-8" }, [
            _c(
              "h2",
              { staticClass: "text-center", attrs: { "data-aos": "fade-up" } },
              [_vm._v("บริการของเรา")]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "text-center", attrs: { "data-aos": "fade-up" } },
              [
                _vm._v(
                  "\n            บริการล้างแอร์บ้านมาตรฐานสูง เพื่อให้คุณได้รับอากาศบริสุทธิ์"
                ),
                _c("br"),
                _vm._v(
                  "\n            สะอาดหมดจด ปราศจากเชื้อโรค และช่วยให้้ประหยัดค่าไฟมากขึ้น"
                ),
                _c("br"),
                _vm._v(
                  "\n            ตรวจเช็คระดับความเย็น ตรวจวัดน้ำยาแอร์ และการทำงานของคอมเพรสเซอร์\n          "
                )
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "contact-us" } }, [
      _c("div", { staticClass: "container-fluid no-gutters p-0" }, [
        _c("div", { staticClass: "row no-gutters" }, [
          _c("div", { staticClass: "col-12 col-md-4" }, [
            _c("div", { staticClass: "box-left" }, [
              _c("h2", { attrs: { "data-aos": "fade-right" } }, [
                _vm._v("CONTACT")
              ]),
              _vm._v(" "),
              _c("h3", { attrs: { "data-aos": "fade-right" } }, [
                _vm._v("ติดต่อใช้บริการ")
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "d-none d-md-block",
                attrs: {
                  "data-aos": "fade-up",
                  src: "/static/img/acCleaning/remote.png",
                  alt: "contact-us"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-8 col-right" }, [
            _c("div", { staticClass: "box-right" }, [
              _c(
                "p",
                {
                  staticClass: "text-center",
                  attrs: { "data-aos": "fade-up" }
                },
                [
                  _vm._v("สำหรับการจองใช้บริการ หรือสอบถามข้อมูลเพิ่มเติม"),
                  _c("br"),
                  _vm._v(
                    "กรุณาคลิกที่ปุ่มด้านล่าง\n              เพื่อนัดหมายการใช้บริการ"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "text-center",
                  attrs: { "data-aos": "fade-up" }
                },
                [
                  _vm._v("หรือ โทร "),
                  _c("span", { staticClass: "tel" }, [
                    _c("a", { attrs: { href: "tel:+6621131138" } }, [
                      _vm._v("02-113-1138")
                    ]),
                    _vm._v(",\n              "),
                    _c("a", { attrs: { href: "tel:+66927572999" } }, [
                      _vm._v("092-757-2999")
                    ])
                  ]),
                  _vm._v("\n              เพื่อติดต่อฝ่ายบริการของเรา")
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn",
                  attrs: {
                    href: "https://line.me/R/ti/p/%40hnk7011n",
                    target: "_blank",
                    "data-aos": "fade-up"
                  }
                },
                [_vm._v("จองเลย")]
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "type-air" } }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-5 text-center align-self-center order-md-1 order-2",
              attrs: { "data-aos": "fade-right" }
            },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: { src: "/static/img/acCleaning/Air1.png" }
              }),
              _c("br"),
              _vm._v(" "),
              _c("span", [_vm._v("น้อยกว่า 24,000 BTU")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-2 align-self-center order-md-2 order-1",
              attrs: { "data-aos": "fade-up" }
            },
            [_c("h2", { staticClass: "text-center" }, [_vm._v("แบบติดผนัง")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 col-md-5 text-center order-md-3 order-3",
              attrs: { "data-aos": "fade-left" }
            },
            [
              _c("img", {
                staticClass: "img-fluid",
                staticStyle: { height: "117px" },
                attrs: { src: "/static/img/acCleaning/Air2.png" }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("มากกว่า 24,000 BTU")])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-5 text-center align-self-center order-md-1 order-2",
              attrs: { "data-aos": "fade-right" }
            },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: { src: "/static/img/acCleaning/Air3.png", width: "350" }
              }),
              _c("br"),
              _vm._v(" "),
              _c("span", [_vm._v("น้อยกว่า 24,000 BTU")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-md-2 align-self-center order-md-2 order-1",
              attrs: { "data-aos": "fade-up" }
            },
            [_c("h2", { staticClass: "text-center" }, [_vm._v("แบบแขวน")])]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-12 col-md-5 text-center order-md-3 order-3",
              attrs: { "data-aos": "fade-left" }
            },
            [
              _c("img", {
                staticClass: "img-fluid",
                attrs: { src: "/static/img/acCleaning/Air4.png", width: "350" }
              }),
              _vm._v(" "),
              _c("span", [_vm._v("มากกว่า 24,000 BTU")])
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "cost-service" } }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "h2",
              { staticClass: "text-center", attrs: { "data-aos": "fade-up" } },
              [_vm._v("อัตราค่าบริการ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "table-responsive" }, [
              _c("table", { staticClass: "table table-bordered text-center" }, [
                _c("thead", [
                  _c("tr", { attrs: { "data-aos": "fade-up" } }, [
                    _c("th", [_vm._v("ประเภท Type")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("ขนาด BTU")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("ค่าบริการก่อน Vat")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("รวมค่าบริการ")])
                  ])
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "title",
                        staticStyle: {
                          background: "#93addb",
                          "font-weight": "500",
                          padding: "30px"
                        },
                        attrs: { rowspan: "2" }
                      },
                      [
                        _vm._v("แบบติดผนัง\n                  "),
                        _c("br"),
                        _vm._v(" (Wall Type)\n                ")
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", { staticStyle: { background: "#cfd5eb" } }, [
                      _vm._v("ไม่เกิน 24,000 BTU")
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { background: "#cfd5eb" } }, [
                      _vm._v("590 บาท")
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          background: "#cfd5eb",
                          color: "red",
                          "font-weight": "500"
                        },
                        attrs: { "data-aos": "zoom-in" }
                      },
                      [_vm._v("631 บาท")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticStyle: { background: "#93addb" } }, [
                      _vm._v("มากกว่า 24,000 BTU")
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { background: "#93addb" } }, [
                      _vm._v("750 บาท")
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          background: "#93addb",
                          color: "red",
                          "font-weight": "500"
                        },
                        attrs: { "data-aos": "zoom-in" }
                      },
                      [_vm._v("803 บาท")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "title",
                        staticStyle: {
                          background: "#7693c7",
                          "font-weight": "500",
                          padding: "30px"
                        },
                        attrs: { rowspan: "2" }
                      },
                      [
                        _vm._v("แบบแขวน "),
                        _c("br"),
                        _vm._v(
                          "\n                  (Ceiling type)\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("td", { staticStyle: { background: "#cfd5eb" } }, [
                      _vm._v("ไม่เกิน 24,000 BTU")
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { background: "#cfd5eb" } }, [
                      _vm._v("990 บาท")
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          background: "#cfd5eb",
                          color: "red",
                          "font-weight": "500"
                        },
                        attrs: { "data-aos": "zoom-in" }
                      },
                      [_vm._v("1,059 บาท")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("td", { staticStyle: { background: "#93addb" } }, [
                      _vm._v("มากกว่า 24,000 BTU")
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { background: "#93addb" } }, [
                      _vm._v("1,200 บาท")
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          background: "#93addb",
                          color: "red",
                          "font-weight": "500"
                        },
                        attrs: { "data-aos": "zoom-in" }
                      },
                      [_vm._v("1,284 บาท")]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "condition" }, [
              _c(
                "p",
                { staticClass: "m-0", attrs: { "data-aos": "fade-up" } },
                [_vm._v("เงื่อนไขการให้บริการ")]
              ),
              _vm._v(" "),
              _c("ul", { staticClass: "list-condition" }, [
                _c("li", { attrs: { "data-aos": "fade-up" } }, [
                  _vm._v(
                    "พิกัดการเข้าให้บริการ (เกินจากนี้ คิดค่าเดินทางเพิ่ม กิโลเมตรละ 6 บาท)"
                  )
                ]),
                _vm._v(" "),
                _c("li", { attrs: { "data-aos": "fade-up" } }, [
                  _vm._v(
                    "เชียงใหม่ : รัศมี 30 กิโลเมตร จาก อ.เมือง จ.เชียงใหม่"
                  )
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "contact-footer" } }, [
      _c("div", { staticClass: "container-fluid no-gutters p-0" }, [
        _c(
          "div",
          {
            staticClass:
              "row justify-content-center no-gutters pb-5 pb-md-0 pt-5 pt-md-0"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "col-12 col-md-3 align-self-center text-center box-left"
              },
              [
                _c("h1", { attrs: { "data-aos": "fade-right" } }, [
                  _vm._v("CONTACT")
                ]),
                _vm._v(" "),
                _c("h3", { attrs: { "data-aos": "fade-right" } }, [
                  _vm._v("ติดต่อใช้บริการ")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "align-self-center col-12 col-md-2 mb-5 mb-md-0 mt-4 mt-md-0 text-center"
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "btn",
                    attrs: {
                      "data-aos": "fade-up",
                      href: "https://line.me/R/ti/p/%40hnk7011n",
                      target: "_blank"
                    }
                  },
                  [_vm._v("จองเลย")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 col-md-4 align-self-center box-right",
                attrs: { "data-aos": "fade-left" }
              },
              [
                _c("p", [_vm._v("คลิกที่ปุ่ม เพื่อนัดหมายการใช้บริการ")]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v("หรือ โทร "),
                  _c("a", { attrs: { href: "tel:+6621131138" } }, [
                    _vm._v("02-113-1138")
                  ]),
                  _vm._v(",\n            "),
                  _c("a", { attrs: { href: "tel:+66927572999" } }, [
                    _vm._v("092-757-2999")
                  ]),
                  _vm._v(" เพื่อติดต่อฝ่ายบริการของเรา")
                ])
              ]
            )
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8400c1a4", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8400c1a4","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/AcCleaning.vue
// module id = 1549
// module chunks = 0